module.exports = __webpack_public_path__ + "img/phone-xmark.b15aff94.svg";